import { EventBase } from "@vp/models";
import { UploadProgressResult } from "../file/upload-progress-result";

export class UploadScanProgressEvent extends EventBase<UploadProgressResult> {
  constructor(result: UploadProgressResult) {
    super();
    this.args = result;
  }
}
